import firebaseCompat from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/functions";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDMw3cG7JR-RrrC-aWNugk_TS1oLBV58qw",
  authDomain: "ap-studybites.firebaseapp.com",
  projectId: "ap-studybites",
  storageBucket: "ap-studybites.appspot.com",
  messagingSenderId: "386062840730",
  appId: "1:386062840730:web:5f3a0c6b23f0be15220023",
  measurementId: "G-8XJMW8N6QS"
};

const app = firebaseCompat.apps.length
  ? firebaseCompat.app()
  : firebaseCompat.initializeApp(firebaseConfig);

// Modular SDK exports for new code paths.
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app, "us-central1");

// Compat exports keep existing query code working during incremental migration.
const legacyDb = app.firestore();
const legacyFunctions = app.functions("us-central1");

// Both dev and production now use the deployed Cloud Functions so that
// feedbackCount writes and Firestore reads go to the same backend.
// To re-enable the local Functions emulator during isolated backend testing,
// uncomment the four lines below (requires `firebase emulators:start --only functions`):
// import { connectFunctionsEmulator } from "firebase/functions";
// if (window.location.hostname === "localhost") {
//   connectFunctionsEmulator(functions, "localhost", 5001);
//   legacyFunctions.useEmulator("localhost", 5001);
// }

export { app, auth, db, functions, legacyDb, legacyFunctions };
